export default __webpack_public_path__ + "static/media/overview.45e056dd.svg";